var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.loading)?_c('div',{staticClass:"text-xs-center"}):(!_vm.url)?_c('div',{staticClass:"text-xs-center"},[_c('v-icon',{attrs:{"x-large":""}},[_vm._v("highlight_off")]),_vm._v(" "),_c('div',[_vm._v("Not found video")])],1):[_vm._t("default",null,null,{ url: _vm.url, mime_type: _vm.mime_type })]],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f8fbf9ca","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/elements/FacebookContent.vue
// module id = null
// module chunks = 